import { useContext } from "react";
import { MenuContext } from "./Contexts/MenuContext";
import { MessageBar, MessageBarButton } from "office-ui-fabric-react";

export const EditableMenuMessage = () => {
  const [menuContext, setMenuContext] = useContext(MenuContext);

  if (!menuContext.menuEditStateDisplay) {
    return <></>;
  }

  return (
    <MessageBar
      messageBarType={menuContext.menuEditStateSeverity}
      isMultiline={false}
      actions={
        <div>
          <MessageBarButton
            onClick={() => {
              setMenuContext((prevState) => ({
                ...prevState,
                menuEditStateDisplay: false,
              }));
            }}
          >
            Got it!
          </MessageBarButton>
        </div>
      }
    >
      {menuContext.menuEditStateMessage}
    </MessageBar>
  );
};

export default EditableMenuMessage;
